// import {useSelector} from "react-redux";
import { Navigate, Outlet } from 'react-router-dom';
const PrivateInvestorRoute = () => {
  // const {userToken } = useSelector( state => state.authReducer );

  const userToken = localStorage.getItem('investorToken');
  return userToken ? <Outlet /> : <Navigate to="/login" />;
};
export default PrivateInvestorRoute;
